import {Vue, Component, Prop} from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';

@Component({
    name: 'comparative-search',
    components: {
        'material-icon': GoogleMaterialIcon,
    },
})

export default class ComparativeSearch extends Vue {

    // -----------------------------------------------------------------
    // Properties
    private searchTerms: string = '';

    private isShowGradeList: boolean = false;

    private get gradeList() {
        return this.$store.state.comparativeStore.gradeList;
    }

    private gradeCode: any = null;

    // --------------------------------------------------------------------------
    // Actions
    private switchSearch() {
        this.$emit('switchSearch');
    }

    private comparativeSearch(gradeCode = this.gradeCode) {
        if (gradeCode) {
            this.$emit('comparativeSearch', {'q': this.searchTerms, 'flt.course': gradeCode});
        } else {
            this.$emit('comparativeSearch', {q: this.searchTerms});
        }

    }

    private onSelectedGrade(selectedGrade: any = null) {
        this.isShowGradeList = false;
        this.gradeCode = selectedGrade ? selectedGrade.gradeCode.toString() : null;
        if (this.searchTerms !== '') {
        this.comparativeSearch(this.gradeCode);
       }
    }



}
